import React from 'react';


const AdditionalSection = ({ content }) => {
  return (
    <section className="additional-section">
      <div className="container">
        <div className="inner-content">
          <div className="left-wrapper">
            <div className="content-wrap">
              <h2>{content.title}</h2>
              <p>{content.description}</p>
              <h3>{content.subTitle}</h3>
              <ul>
                {content.benefits.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
          <div className="right-wrapper">
            {content.images.map((img, index) => (
              <div className="img-box" key={index}>
                <img src={img} alt={`Additional Service ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdditionalSection;
